// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Open Sans', 'Open Sans Fallback'","fontStyle":"normal"},"className":"__className_2fad4c","variable":"__variable_2fad4c"};